/**
 * 
 * @param variant The shopify product variant object
 * @returns A string with all the options of the variant, seperated by commas
 */
export function getVariantName(variant: any) {
  if (!variant.selectedOptions) {
    return null
  }

  let name = ''

  let parts = 0
  for (const entry of variant.selectedOptions) {
    if (entry?.name !== 'Title') {
      if (parts !== 0) {
        name += ', '
      }
      name += entry.value
      parts++
    }
  }

  if (name.length === 0) {
    return null
  } else {
    return name
  }
}